"use strict";
import { jsx } from "react/jsx-runtime";
export default function LoadTmsDeletedWarning() {
  return /* @__PURE__ */ jsx("span", { className: "load_tms_deleted_warning_icon", children: /* @__PURE__ */ jsx("a", { href: "#", children: /* @__PURE__ */ jsx("span", { "data-tooltip": true, "aria-haspopup": "true", title: "Removed from TMS", children: /* @__PURE__ */ jsx("i", { className: "fi-alert" }) }) }) });
}
